import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export function computeTotals(subtotal, settings) {
  const threshold = Number(settings?.free_shipping_threshold ?? 1000);
  const fee = Number(settings?.standard_shipping_fee ?? 10);
  const g = Number(settings?.gst_rate ?? 15) / 100;
  const free = subtotal >= threshold;
  const shipping = free ? 0 : fee;
  const total = subtotal + shipping;
  const gstIncluded = total * (g / (1 + g));
  return { subtotal, shipping, total, gstIncluded, free, threshold, remaining: Math.max(0, threshold - subtotal) };
}
